import { render, staticRenderFns } from "./Vats.vue?vue&type=template&id=6a9517bd&"
import script from "./Vats.vue?vue&type=script&lang=js&"
export * from "./Vats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports